import {
  Box,
  Button,
  ButtonGroup,
  HStack,
  Image,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useBreakpointValue,
  useDisclosure,
} from '@chakra-ui/react';
import { headerLinks, headerLinksEn } from '../../constants/links';

import Banner from './Banner';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { MobileDrawer } from './MobileNavbar';
import React from 'react';
import { ToggleButton } from './ToggleButton';
import useAuth from '../../hooks/useAuth';
import useLanguage from '../../hooks/useLanguage';

export const NavBar = () => {
  const isEnglish = useLanguage();

  const isDesktop = useBreakpointValue({ base: false, md: true });
  const { loggedIn } = useAuth();
  const mobileNavbar = useDisclosure();

  const navLinks = isEnglish ? headerLinksEn : headerLinks;
  return (
    <>
      <Banner />
      <Box
        as="header"
        h={{ base: '84px', lg: '84px' }}
        borderBottom="1px solid #EEEDF1"
        px={{ base: '16px', md: '20px', xl: '20px', xxl: '0px', '2xl': '0px' }}
      >
        <HStack
          maxW="1280px"
          margin="0px auto"
          h="100%"
          justify="space-between"
        >
          <Link href={isEnglish ? "/en" : "/"} aria-label="Link to home page">
            <Image
              src="https://www.svetionikznanja.afirmacijakulture.org/wp-content/uploads/sites/3/sites/3/2024/10/sz_logo-1.webp"
              alt="Svetionik Logo"
              // w="80px"
              h="68px"
            />
          </Link>
          {isDesktop ? (
            <HStack spacing="0px" >
              <ButtonGroup size="lg" variant="text" colorScheme="gray" alignItems="center">
                <Menu>
                  <MenuButton as={Button} rightIcon={<ChevronDownIcon color="rawSienna.500" w="16px" h="16px" />} >
                    <Text fontSize="16px" color="rawSienna.500" fontWeight="600"> {isEnglish ? "About the Project" : "О пројекту"}</Text>
                  </MenuButton>
                  <MenuList>
                    <Link href={isEnglish ? "/en/about" : "/o-nama"} fontWeight="600"><MenuItem>{isEnglish ? "About us" : "O нама"}</MenuItem> </Link>
                    <Link href={isEnglish ? "/en/lighthouse-generations" : '/generacije-svetionika'} fontWeight="600"><MenuItem>{isEnglish ? "Lighthouse Generations" : "Генерације светионика"}</MenuItem></Link>
                  </MenuList>
                </Menu>
                {navLinks.map((item: { text: string; href: string }) => (
                  <Link
                    key={item.text}
                    fontSize="16px"
                    fontWeight="600"
                    href={item.href}
                    p="10px 24px"
                    color='rawSienna.500'
                    marginInlineStart="0px"
                    _hover={{
                      color: 'rawSienna.700',
                      textDecor: 'none',
                    }}
                  >
                    {item.text}
                  </Link>
                ))}
              </ButtonGroup>
              {loggedIn && (
                <Link href="https://classroom.google.com/h">
                  <Button variant="solid">Google clasroom</Button>
                </Link>
              )}
            </HStack>
          ) : (
            <>
              <HStack gap="6px">
                {loggedIn && (
                  <Link href="https://classroom.google.com/h">
                    <Button variant="outline" h="40px" fontSize="14px">
                      Google clasroom
                    </Button>
                  </Link>
                )}
                <ToggleButton
                  onClick={mobileNavbar.onToggle}
                  isOpen={mobileNavbar.isOpen}
                  aria-label="Open Menu"
                />
              </HStack>

              <MobileDrawer
                isOpen={mobileNavbar.isOpen}
                onClose={mobileNavbar.onClose}
              />
            </>
          )}
        </HStack>
      </Box >
    </>
  );
};
